export const getPlanList = (state: any) => state.plan.planList;
export const getPlanDetail = (state: any) => state.plan.planDetail;
